import { MiscUtil } from '@/utils/miscUtil';
import axios from 'axios';
import qs from 'qs'
export const queryRolePageList = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/role/queryRoleForPage'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const addRole = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/role/addRole'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const editRole = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/role/editRole'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const deleteRole = (roleID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/role/deleteRole'),
    params: {
      roleID
    },
    method: 'post'
  })
}
export const queryUserRoleByProperties = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserRoleByProperties'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const editUserRole = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/editUserRole'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
